import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
export type JobInfoHeaderFieldsFragment = {
    __typename?: 'AutoApplyDraft';
    applicationDraftId: string;
    iaUid: string;
    jobTitle: string;
    jobLocation: string;
    employerName?: string | null | undefined;
    applyableJob: {
        __typename?: 'ReviewBeforeSubmitApplyableJob';
        clientJobRef?: string | null | undefined;
    };
};

export const JobInfoHeaderFieldsFragmentDoc = gql`
    fragment JobInfoHeaderFields on AutoApplyDraft {
        applicationDraftId
        iaUid
        jobTitle
        jobLocation
        employerName
        applyableJob {
            clientJobRef
        }
    }
`;
